import { environment } from '../../environment'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export type UseApiStore = {
  reset: () => void;
  refreshTokenIsLoading: boolean;
  setRefreshTokenIsLoading: (boolean) => void;
}

const initialData = {
  refreshTokenIsLoading: false
}

export const useApiStore = create<UseApiStore>(
  devtools
    ((set, get) => ({
      ...initialData,
      reset:()=> set({ ...initialData }),
      setRefreshTokenIsLoading: (token) => set({ refreshTokenIsLoading:token})
    }))
)

export const ApiStore = useApiStore.getState()